/**
 * <ExtendStayDrawer> — canonical per AR-7.
 */
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { OperationalDrawer, BottomActionBar } from "@/components/operational";
import { CalendarClock } from "lucide-react";
import { foApi , formatApiError } from "../foApi";
import { DatePicker } from "@/components/ui/date-picker";

export default function ExtendStayDrawer({ open, onOpenChange, stay, onSuccess }) {
  const [newDep, setNewDep] = useState("");
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setNewDep((stay?.expected_departure || "").slice(0, 10));
  }, [open, stay?.expected_departure]);

  const submit = async () => {
    if (!newDep) { toast.error("Pick a new departure date"); return; }
    setSaving(true);
    try {
      await foApi.extendStay(stay.id, { new_departure: newDep, reason });
      onSuccess?.();
    } catch (e) {
      toast.error(formatApiError(e, "Extend failed"));
    } finally { setSaving(false); }
  };

  return (
    <OperationalDrawer open={open} onOpenChange={onOpenChange}
      title="Extend Stay" subtitle={stay?.code}
      size="sm" testid="extend-drawer"
      footer={
        <BottomActionBar
          primary={{ label: saving ? "Extending..." : "Confirm Extension",
                       icon: CalendarClock, tone: "primary", onClick: submit,
                       loading: saving, disabled: !newDep,
                       testid: "extend-confirm" }}
          secondaryActions={[
            { label: "Cancel", tone: "secondary", onClick: () => onOpenChange(false), testid: "extend-cancel" }
          ]}
        />
      }>
      <div className="p-4 space-y-4">
        <div>
          <label className="text-[12px] uppercase tracking-wider text-slate-500 font-semibold">Current departure</label>
          <div className="text-[16px] font-semibold mt-1">{(stay?.expected_departure || "").slice(0, 10)}</div>
        </div>
        <div>
          <label className="text-[12px] uppercase tracking-wider text-slate-500 font-semibold">New departure</label>
          <DatePicker value={(newDep || '').slice(0,10)} onChange={(_v) => setNewDep(_v)} data-testid="extend-date"/>
        </div>
        <div>
          <label className="text-[12px] uppercase tracking-wider text-slate-500 font-semibold">Reason</label>
          <textarea value={reason} onChange={e => setReason(e.target.value)}
                      className="w-full mt-1 border-2 border-slate-300 rounded-lg p-2 text-[14px] min-h-[60px]"
                      data-testid="extend-reason"/>
        </div>
      </div>
    </OperationalDrawer>
  );
}
